import Table from './Table/Table.js'

export default Table
